import { render, staticRenderFns } from "./ProductDeletingSettings.vue?vue&type=template&id=f26aeeae"
import script from "./ProductDeletingSettings.vue?vue&type=script&lang=js"
export * from "./ProductDeletingSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports